
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Tree from "react-d3-tree";

const Team = () => {
  const [treeData, setTreeData] = useState(null);
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
const [currentRoot, setCurrentRoot] = useState(null);
const [fullTree, setFullTree] = useState(null);



  // Track container size
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const { width, height } = containerRef.current.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [translate, setTranslate] = useState({ x: 0, y: 50 });

useEffect(() => {
  if (containerRef.current) {
    const { width, height } = containerRef.current.getBoundingClientRect();
    setTranslate({ x: width / 2, y: 50 }); 
  }
}, [dimensions.width]);

  const transformToBinaryTreeWithCollapse = (
  node,
  currentLevel = 1,
  maxVisibleLevel = 2
) => {
  const newNode = {
    ...node,
  };

  if (node.children && node.children.length > 0) {
    newNode.children = node.children.slice(0, 2).map((child) =>
      transformToBinaryTreeWithCollapse(
        child,
        currentLevel + 1,
        maxVisibleLevel
      )
    );
  }

  if (currentLevel >= maxVisibleLevel) {
    newNode.collapsed = true;
  }

  return newNode;
};



const handleNodeClick = (nodeDatum) => {
  if (nodeDatum.children && nodeDatum.children.length > 0) {
    // Drill down
    setCurrentRoot(nodeDatum);
  }
};

 
  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const maxLevel = dimensions.width < 768 ? 1 : 2;
        const res = await axios.get("https://api.bigfresh.in/tree-team");
        const binaryTreeData = transformToBinaryTreeWithCollapse(res.data, 1, maxLevel);
        setTreeData([binaryTreeData]);

        console.log(binaryTreeData)
      } catch (err) {
        console.error(err);
      }
    };
    fetchTeam();
  }, [dimensions.width]);






  if (!treeData) return <div>Loading...</div>;

  
const renderNode = ({ nodeDatum }) => {
  const width = 200;
  const height = 120;

  return (
    <foreignObject
      width={width}
      height={height}
      x={-width / 2}
      y={-height / 2}
    >
      <div className="tree-node">
        <h6 className="mb-1">{nodeDatum.name}</h6>
        <small>ID: {nodeDatum.id}</small>
        <span>{nodeDatum.email}</span>
        {nodeDatum.role && <small>{nodeDatum.role}</small>}
      </div>
    </foreignObject>
  );
};


  const initialTranslate = { x: dimensions.width / 2, y: 50 };
  const nodeSize = { x: 120, y: 140 };

  return (
    <>
      <h4 className="text-center fw-bold text-success">Team</h4>
      <div
        ref={containerRef}
        style={{ width: "100%", height: "80vh", overflow: "hidden" }} 
      >
     

        <Tree
          data={treeData}
            // data={currentRoot ? [currentRoot] : []}
  renderCustomNodeElement={renderNode}
          nodeSize={nodeSize}
          orientation="vertical"
          pathFunc="step"
          // renderCustomNodeElement={renderNode}
          collapsible={true}
          zoomable={false} 
          translate={initialTranslate}
          intitalDepth={2}
        />
      </div>
    </>
  );
};

export default Team;






// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import Tree from "react-d3-tree";

// const Team = () => {
//   const [treeData, setTreeData] = useState(null);
//   const [currentRoot, setCurrentRoot] = useState(null);
//   const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
//   const containerRef = useRef(null);

//   const [translate, setTranslate] = useState({ x: 0, y: 50 });

//   // Track container size and adjust the translate position
//   useEffect(() => {
//     const handleResize = () => {
//       if (containerRef.current) {
//         const { width, height } = containerRef.current.getBoundingClientRect();
//         setDimensions({ width, height });
//         setTranslate({ x: width / 2, y: 50 });
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [dimensions.width]);

//   // Function to transform the API data into a tree structure with collapsible nodes
//   const transformToBinaryTreeWithCollapse = (node, currentLevel = 1, maxVisibleLevel = 2) => {
//     const newNode = { ...node };

//     // Recursively apply transformation to children
//     if (node.children && node.children.length > 0) {
//       newNode.children = node.children.slice(0, 2).map((child) =>
//         transformToBinaryTreeWithCollapse(child, currentLevel + 1, maxVisibleLevel)
//       );
//     }

//     // Collapse nodes after the max visible level
//     if (currentLevel >= maxVisibleLevel) {
//       newNode.collapsed = true;
//     }

//     return newNode;
//   };

//   // Handle node clicks for drilling down
//   const handleNodeClick = (nodeDatum) => {
//     if (nodeDatum.children && nodeDatum.children.length > 0) {
//       setCurrentRoot(nodeDatum); // Drill down into this node
//     }
//   };

//   // Fetch the tree data from the API
//   useEffect(() => {
//     const fetchTeam = async () => {
//       try {
//         const maxLevel = dimensions.width < 768 ? 1 : 2; // Change collapse level based on screen size
//         const res = await axios.get("https://api.bigfresh.in/tree-team");
//         const binaryTreeData = transformToBinaryTreeWithCollapse(res.data, 1, maxLevel);
//         setTreeData([binaryTreeData]); // Wrap in an array for the root structure
//         setCurrentRoot(binaryTreeData); // Set the initial root for the tree
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchTeam();
//   }, [dimensions.width]);

//   // Render custom node element with relevant information and custom styles
//   const renderNode = ({ nodeDatum }) => {
//     const width = 200;
//     const height = 120;

//     return (
//       <foreignObject width={width} height={height} x={-width / 2} y={-height / 2}>
//         <div className="tree-node">
//           <div className="node-header">
//             <h6>{nodeDatum.name}</h6>
//             <small>ID: {nodeDatum.id}</small>
//           </div>
//           <div className="node-body">
//             <div>{nodeDatum.email}</div>
//             {nodeDatum.role && <small>{nodeDatum.role}</small>}
//           </div>
//         </div>
//       </foreignObject>
//     );
//   };

//   // Set initial translate position based on window size
//   const nodeSize = { x: 210, y: 160 };

//   // If treeData is still loading, show a loading message
//   if (!treeData) return <div>Loading...</div>;

//   return (
//     <>
//       <h4 className="text-center fw-bold text-success">Team</h4>
//       <div
//         ref={containerRef}
//         style={{ width: "100%", height: "80vh", overflow: "hidden" }}
//       >
//         <Tree
//           data={currentRoot ? [currentRoot] : treeData} // Use currentRoot if available, else the full tree
//           renderCustomNodeElement={renderNode}
//           nodeSize={nodeSize}
//           orientation="vertical"
//           pathFunc="step"
//           collapsible={true} // Allow collapsing
//           zoomable={false}  // Disable zooming for better usability
//           translate={translate}
//           onNodeClick={handleNodeClick} // Enable drilling down on node click
//         />
//       </div>
//     </>
//   );
// };

// export default Team; // Correct default export
                                       





// import React, { useState, useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Recursive Tree Item
// const TreeNode = ({ node }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <div className="mb-1">
//       <div
//         onClick={() => setOpen(!open)}
//         style={{ cursor: 'pointer', fontWeight: 'bold' }}
//         className="p-2 bg-light border rounded"
//       >
//         {node.name} ({node.user_id})
//       </div>

//       {open && node.children && node.children.length > 0 && (
//         <div className="ml-4 border-left pl-3 mt-1">
//           {node.children.map(child => (
//             <TreeNode key={child.id} node={child} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const TeamTree = () => {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     fetch("https://api.bigfresh.in/tree-team")
//       .then(res => res.json())
//       .then(tree => setData(tree))
//       .catch(err => console.error("API Error:", err));
//   }, []);

//   if (!data) return <div className="text-center mt-5">Loading...</div>;

//   return (
//     <div className="container mt-4">
//       <h2 className="text-center">Big Fresh Mart Team Tree</h2>
//       <TreeNode node={data} />
//     </div>
//   );
// };

// export default TeamTree;


// import React, { useState, useEffect } from "react";
// import Tree from "react-d3-tree";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from 'axios'
// // Convert API node into a binary tree format
// const convertBinary = (node) => {
//   const leftChild = node.children?.[0] || null;
//   const rightChild = node.children?.[1] || null;

//   return {
//     name: `${node.name} (${node.user_id})`,
//     attributes: {
//       Phone: node.phone || "-",
//       Email: node.email || "-",
//     },
//     // Hidden children stored here
//     _children: [
//       leftChild ? convertBinary(leftChild) : null,
//       rightChild ? convertBinary(rightChild) : null,
//     ].filter(Boolean),
//     children: [], // starts collapsed
//   };
// };

// const TeamTree = () => {
//   const [treeData, setTreeData] = useState(null);

//   useEffect(() => {
   
//     fetchTeam();
//   }, []);

//  const fetchTeam = async () => {
//       try {
      
//         const res = await axios.get("https://api.bigfresh.in/tree-team");
//         console.log(res.data,'tree data')
//       } catch (err) {
//         console.error(err);
//       }
//     };
 

//   if (!treeData)
//     return <div className="text-center mt-5">Loading...</div>;

//   return (
//     <div style={{ width: "100%", height: "95vh" }}>
//       <h3 className="text-center mb-3">Big Fresh Mart Binary Tree</h3>

//       <Tree
//         data={treeData}
//         collapsible={true}          // builtin collapsible
//         orientation="vertical"
//         pathFunc="elbow"
//         translate={{ x: window.innerWidth / 2, y: 60 }}
//         nodeSize={{ x: 260, y: 150 }}

//         renderCustomNodeElement={(rd3tProps) => (
//           <g>
//             {/* Node Box */}
//             <rect
//               width="260"
//               height="110"
//               x="-130"
//               y="-55"
//               fill="#ffffff"
//               stroke="#444"
//               strokeWidth="2"
//               rx="8"
//             />

//             {/* Node Text */}
//             <text
//               x="0"
//               y="-25"
//               textAnchor="middle"
//               style={{ fontSize: "14px", fontWeight: "bold" }}
//             >
//               {rd3tProps.nodeDatum.name}
//             </text>

//             {/* Attributes */}
//             {Object.entries(rd3tProps.nodeDatum.attributes).map(
//               ([key, value], i) => (
//                 <text
//                   key={i}
//                   x="0"
//                   y={-5 + i * 18}
//                   textAnchor="middle"
//                   style={{ fontSize: "12px" }}
//                 >
//                   {key}: {value}
//                 </text>
//               )
//             )}
//           </g>
//         )}
//       />
//     </div>
//   );
// };

// export default TeamTree;




























// import React, { useState, useEffect } from "react";
// import Tree from "react-d3-tree";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";

// const TeamTree = () => {
//   const [treeData, setTreeData] = useState(null);

//   useEffect(() => {
//     fetchTeam();
//   }, []);

//   // Fetch the full tree from API
//   const fetchTeam = async () => {
//     try {
//       const res = await axios.get("https://api.bigfresh.in/tree-team");
//       console.log(res.data, "tree data");
//       const formattedTree = buildBinaryTree(res.data, 0);
//       setTreeData(formattedTree);
//     } catch (err) {
//       console.error(err);
//     }
//   };


//   const buildBinaryTree = (node, level = 0) => {
//     if (!node) return null;

//     const left = node.children?.[0] || null;
//     const right = node.children?.[1] || null;

//     const formattedNode = {
//       name: `${node.name} (${node.user_id})`,
//       attributes: {
//         Phone: node.phone || "-",
//         Email: node.email || "-",
//       },
//     };

//     if (level < 1) {
   
//       formattedNode.children = [
//         left ? buildBinaryTree(left, level + 1) : null,
//         right ? buildBinaryTree(right, level + 1) : null,
//       ].filter(Boolean);
//     } else {
//       // Store remaining children hidden for recursive expansion
//       formattedNode._children = [
//         left ? buildBinaryTree(left, level + 1) : null,
//         right ? buildBinaryTree(right, level + 1) : null,
//       ].filter(Boolean);
//       formattedNode.children = [];
//     }

//     return formattedNode;
//   };



//   if (!treeData)
//     return <div className="text-center mt-5">Loading team tree...</div>;

//   return (
//     <div style={{ width: "100%", height: "95vh" }}>
//       <h3 className="text-center mb-3">Big Fresh Mart Binary Tree</h3>

//       <Tree
//         data={treeData}
//         orientation="vertical"
//         pathFunc="elbow"
//         translate={{ x: window.innerWidth / 2, y: 80 }}
//         nodeSize={{ x: 280, y: 160 }}
//         collapsible={true}
//         onNodeClick={(nodeData) => {
//           if (nodeData.data._children) {
//             nodeData.data.children = nodeData.data._children;
//             nodeData.data._children = null;
//             setTreeData({ ...treeData }); 
//           }
//         }}

        
//         renderCustomNodeElement={(rd3tProps) => (
//           <g>

//             <rect
//               width="260"
//               height="110"
//               x="-130"
//               y="-55"
//               fill="#fff"
//               stroke="#333"
//               strokeWidth="2"
//               rx="8"
//             />

//             {/* Node Name */}
//             <text
//               x="0"
//               y="-25"
//               textAnchor="middle"
//               style={{ fontSize: "14px", fontWeight: "bold" }}
//             >
//               {rd3tProps.nodeDatum.name}
//             </text>

//             {/* Attributes */}
//             {Object.entries(rd3tProps.nodeDatum.attributes).map(
//               ([key, value], i) => (
//                 <text
//                   key={i}
//                   x="0"
//                   y={-5 + i * 18}
//                   textAnchor="middle"
//                   style={{ fontSize: "12px" }}
//                 >
//                   {key}: {value}
//                 </text>
//               )
//             )}
//           </g>
//         )}
//       />
//     </div>
//   );
// };

// export default TeamTree;



// import React, { useState, useEffect } from "react";
// import Tree from "react-d3-tree";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";

// const TeamTree = () => {
//   const [treeData, setTreeData] = useState(null);

//   useEffect(() => {
//     fetchTeam();
//   }, []);

//   // Fetch tree from API
//   const fetchTeam = async () => {
//     try {
//       const res = await axios.get("https://api.bigfresh.in/tree-team");
//       console.log(res.data, "tree data");
//       const formattedTree = buildBinaryTree(res.data, 0);
//       setTreeData(formattedTree);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // Build binary tree recursively with hidden children
//   const buildBinaryTree = (node, level = 0) => {
//     if (!node) return null;

//     const left = node.children?.[0] || null;
//     const right = node.children?.[1] || null;

//     const formattedNode = {
//       name: `${node.name} (${node.user_id})`,
//       attributes: {
//         Phone: node.phone || "-",
//         Email: node.email || "-",
//       },
//       children: [],  // visible nodes
//       _children: [], // hidden nodes
//     };

//     if (left) formattedNode._children.push(buildBinaryTree(left, level + 1));
//     if (right) formattedNode._children.push(buildBinaryTree(right, level + 1));


//     if (level < 1) {
//       formattedNode.children = formattedNode._children;
//       formattedNode._children = [];
//     }

//     return formattedNode;
//   };


//   const toggleNode = (node) => {
//     if (node._children && node._children.length > 0) {

//       node.children = node._children;
//       node._children = [];
//     } else if (node.children && node.children.length > 0) {
 
//       node._children = node.children;
//       node.children = [];
//     }
//   };


//   const handleNodeClick = (clickedNode, currentNode) => {
//     if (clickedNode === currentNode) {
//       toggleNode(currentNode);
//     } else if (currentNode.children) {
//       currentNode.children.forEach((child) =>
//         handleNodeClick(clickedNode, child)
//       );
//     }
//   };

//   if (!treeData)
//     return <div className="text-center mt-5">Loading team tree...</div>;

//   return (
//     <div style={{ width: "100%", height: "95vh" }}>
//       <h3 className="text-center mb-3">Big Fresh Mart Binary Tree</h3>

//       <Tree
//         data={treeData}
//         orientation="vertical"
//         pathFunc="elbow"
//         translate={{ x: window.innerWidth / 2, y: 80 }}
//         nodeSize={{ x: 280, y: 160 }}
//         collapsible={true}
//         onNodeClick={(nodeData) => {
//           handleNodeClick(nodeData.data, treeData);
//           setTreeData({ ...treeData }); 
//         }}
//         renderCustomNodeElement={(rd3tProps) => (
//           <g>
//             <rect
//               width="260"
//               height="110"
//               x="-130"
//               y="-55"
//               fill="#fff"
//               stroke="#333"
//               strokeWidth="2"
//               rx="8"
//             />

//             <text
//               x="0"
//               y="-25"
//               textAnchor="middle"
//               style={{ fontSize: "14px", fontWeight: "bold" }}
//             >
//               {rd3tProps.nodeDatum.name}
//             </text>

//             {Object.entries(rd3tProps.nodeDatum.attributes).map(
//               ([key, value], i) => (
//                 <text
//                   key={i}
//                   x="0"
//                   y={-5 + i * 18}
//                   textAnchor="middle"
//                   style={{ fontSize: "12px" }}
//                 >
//                   {key}: {value}
//                 </text>
//               )
//             )}
//           </g>
//         )}
//       />
//     </div>
//   );
// };

// export default TeamTree;